import { distortionClass, distortionBar } from './index';

const topMainVisual = (() => {
  const pageTop = (document.getElementById("pageTop") != null);
  if (pageTop) {



    let sW = window.innerWidth;

    const jsSecMain = document.getElementById('jsSecMain');

    let jsMainVideo = jsSecMain.querySelector('#jsMainVideo')

    let jsMainTxt = jsSecMain.querySelector('#jsMainTxt')

    let jsPatchBox = jsSecMain.querySelector('#jsPatchBox')


    window.addEventListener('load', () => {
      setTimeout(() => {
        gsap.to(jsMainTxt, {
          opacity: 1,
          duration: 0,
          // stagger: {
          //   amount: 2,
          //   from: 'random',
          // },
          onComplete: () => {
            startFunc()
          },
        });
      }, 0)

      const startFunc = () => {
        gsap.to('#jsMainImgBox', {
          opacity: 1,
          duration: .8,
          filter: "blur(0px)",
          onComplete: () => {
            // setInterval(slide.nextSlide, 5000, { passive: true });
            // distortionBar(0)
            jsMainVideo.play()
            jsPatchBox.classList.add('act')
          },
        });
      }
    });


    ScrollTrigger.create({
      trigger: jsSecMain,
      start: '50px top',
      endTrigger: "body",
      end: 'bottom top',
      toggleClass: { targets: jsPatchBox, className: "opacity0" },
      // markers: true,
    });


  }
})();
export default topMainVisual;